/**
 * Created by wython on 2017/11/30.
 */
import Article from './article.vue';

export default Article;



// WEBPACK FOOTER //
// ./src/pages/Article/index.js